import React, { useState, useEffect } from 'react';
import { noticeInfo as noticeInfoReq, updateReadStatus} from '../../../../services/saas/oa';
import { useParams } from 'react-router';
import func from '@/utils/Func';

function NoticeDetail(props) {
  const locationParam = useParams();
  const { receiveId,noticeId }  = locationParam;
  const [noticeInfo,setNoticeInfo] = useState({});

  const getNoticeInfo = async function () {
    const response = await noticeInfoReq({ id:noticeId });
    if (response&&response.success && response.data) {
      setNoticeInfo(response.data);
    }
  }

  useEffect(()=>{
    getNoticeInfo();
    if(receiveId&&receiveId !== 'readed'){
      updateRead();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  //标记已读
  const updateRead = function(){
    updateReadStatus({ id:receiveId });
  }

  return (
    <div className='notice-detail'>
      <div className='notice-detail-title'>{noticeInfo.name}</div>
      <div className='notice-detail-dept'>
        <span className='notice-detail-dept-name'>{noticeInfo.deptName}</span>
        <span className='notice-detail-dept-publish-time'>{func.timeToDif('',noticeInfo.publishTime)}</span>
      </div>
      <div className='notice-detail-content'>
        {noticeInfo.content?<div dangerouslySetInnerHTML={{__html:decodeURIComponent(noticeInfo.content)}}/>:null}
      </div>
      {/* {
              noticeInfo.notificationAttachments ?(
                <div className='notice-detail-file'>
                  <label>附件：</label>
                  <ul>
                    {
                      noticeInfo.notificationAttachments.map((item,index) => (
                          <li key={index}>
                            {index+1}. {item.attachmentName}
                          </li>
                        ))
                    }
                  </ul>
                </div>):null
      } */}
    </div>
  );
}

export default NoticeDetail;


